import { css } from "styled-components";
import { BladeContent } from "../../../../../../components/BladeContent";
import { BladeHeader } from "../../../../../../components/BladeHeader";
export const contentSpaces = {
    desktopAndTabletLarge: "32px",
    desktopAndTabletSmall: "16px",
    mobileLarge: "24px",
    mobileSmall: "12px",
};
export const riotProductSkin = (chroma) => css `
  & {
    align-items: center;

    ${BladeContent} {
      display: flex;
      text-align: center;
      align-content: center;
      justify-content: center;
    }

    .game-icon-no-label {
      .game-icon {
        height: 56px;
        margin-bottom: 32px;

        ${chroma.mediaQueries.tabletDown} {
          height: 42px;
          margin-bottom: 24px;
        }

        .game-icon-img {
          width: auto;
          height: 100%;
        }
      }
    }

    ${BladeHeader} {
      width: 100%;
      ${chroma.mediaQueries.desktopUp} {
        max-width: 783px;
      }

      .bladeheader-body-text {
        max-width: 783px;
      }

      .bladeheader-heading {
        display: flex;
        flex-direction: column;
        align-items: center;

        h2 {
          text-wrap: balance;
        }

        .platform-icons {
          width: 100%;
          justify-content: center;

          svg {
            margin: 0 ${contentSpaces.mobileSmall};

            ${chroma.mediaQueries.desktopUp} {
              margin: 0 ${contentSpaces.desktopAndTabletSmall};
            }
          }
        }
      }
    }
  }
`;
//# sourceMappingURL=index.js.map